import React, { useEffect, useRef, useState } from "react";
import "./CabBookingForm.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container, Row, Col, Card, Form, Spinner } from "react-bootstrap";
import { BsArrowLeftRight } from "react-icons/bs";
// import FlightDeal from "../../../components/MainHome/Home/innerComponents/FlightDeal";
import { MdFlight, MdOutlineFlight } from "react-icons/md";
import { FaHotel, FaSuitcaseRolling, FaWallet } from "react-icons/fa";
import moment from "moment";
import { BiSolidOffer } from "react-icons/bi";
import { IoBagHandleOutline } from "react-icons/io5";
import { BiSupport } from "react-icons/bi";
import Slider from "react-slick";
import { DayPickerRangeController } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
// import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
// import { CountriesArray } from "../FlightSearchMobile/Countries";
// import { cities2 } from "./Cities";
import axios from "axios";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { AiOutlineSwap } from "react-icons/ai";
import { MdCardTravel } from "react-icons/md";
import { BiTransferAlt } from "react-icons/bi";
import { IoLocationOutline } from "react-icons/io5";
import SearchFormAirport from "./SearchFormAirport";
import SearchFormOutstation from "./SearchFormLocal";
import SearchFormLocal from "./SearchFormLocal";
import HotelsContainer from "../../Hotel/HotelSearch/HotelComponent";
import WhyBookUsNew from "../../Home/Home/WhyBookUsNew";
import MobileApp from "../../Flight/FlightSearchMobile/MobileApp";
import WebOffer from "../../Home/Home/WebOffer";
import AboutHome from "../../Home/Home/AboutHome";
import CabContainer from "../CabSearch/CabContainer";
import { toast } from "react-toastify";
// import DateTimePicker from 'react-datetime-picker';

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

export var settings = {
  dots: false,
  autoplay: true,
  autoplaySpeed: 1500,
  infinite: true,
  speed: 100,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export const extractBracketValue = (str) => {
  const regex = /\(([^)]+)\)/;
  const match = regex.exec(str);
  return match ? match[1] : null;
};
const cityToAirportCode = {
  Dubai: "DXB",
  Delhi: "DEL",
  Mumbai: "BOM",
  "New York": "JFK",
  London: "LHR",
  Paris: "CDG",
  Singapore: "SIN",
  // Add more cities as needed
};
const CabBookingForm = () => {
  const [fromCurrency, setFromCurrency] = useState("INR");
  const [toCurrency, setToCurrency] = useState("USD");
  const [convertedAmount, setConvertedAmount] = useState(null);
  const [exchangeRate, setExchangeRate] = useState(null);
  // const [formData, setFormData] = useState({
  //   from: "",
  // });
  const [pickupData, setPickupData] = useState({
    pickup: "",
  });
  const [dropData, setDropData] = useState({
    drop: "",
  });
  const [transferType, setTransferType] = React.useState("Airport PickUp");
  const [startDate, setStartDate] = useState(dayjs());
  const [startTime, setStartTime] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedHours, setSelectedHours] = useState("");

  useEffect(() => {
    const URL = `https://admin.travelsdata.com/api/currency_convert/${fromCurrency}/${toCurrency}`;
    const getExchangeRate = async () => {
      try {
        const response = await axios.get(URL);
        const rate = response.data.data.Conversion_Rate;
        // console.log("ratetetesafdfs", rate);
        setExchangeRate(rate);
      } catch (error) {
        console.error("Error fetching exchange rate:", error);
      }
    };
    if (fromCurrency !== toCurrency) {
      getExchangeRate(URL);
    } else {
      setExchangeRate(1);
    }
    // getExchangeRate()
  }, []);

  const [active, setActive] = useState(true);
  const [active2, setActive2] = useState(false);
  const [active3, setActive3] = useState(false);

  // for Outstation, Transfer and Local

  const [activeTransfer, setActiveTransfer] = useState(true);
  const [activeOutstation, setActiveOutstation] = useState(false);
  const [activeLocal, setActiveLocal] = useState(false);

  const handleSearchFlight = () => {
    setActive(true);
    setActive2(false);
    setActive3(false);
    setEndDate(null);
  };
  const handleSearchFlightRound = () => {
    setActive2(true);
    setActive(false);
    setActive3(false);
  };
  const handleSearchFlightMultiPle = () => {
    setActive3(true);
    setActive(false);
    setActive2(false);
  };

  // For Cabs

  const handleSearchTransfer = () => {
    setActiveTransfer(true);
    setActiveOutstation(false);
    setActiveLocal(false);
  };
  const handleSearchOutstation = () => {
    setActiveTransfer(false);
    setActiveOutstation(true);
    setActiveLocal(false);
  };

  const handleSearchLocal = () => {
    setActiveTransfer(false);
    setActiveOutstation(false);
    setActiveLocal(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setBreakpoints();
    };
    window.addEventListener("resize", handleResize);
    setBreakpoints();
    return () => window.removeEventListener("resize", handleResize);
  });

  const setBreakpoints = () => {
    const isSmallScreen = window.innerWidth <= 768;
    const isMediumScreen = window.innerWidth > 768 && window.innerWidth <= 992;

    if (isSmallScreen) {
      setDateRangeConfig(1, 30, 30);
    } else if (isMediumScreen) {
      setDateRangeConfig(1, 40, 60);
    } else {
      setDateRangeConfig(2, 40, 50);
    }
  };

  const setDateRangeConfig = (numberOfMonths, daysize) => {
    setNumberOfMonths(numberOfMonths);
  };

  const [numberOfMonths, setNumberOfMonths] = useState(2);

  // const [startDate, setStartDate] = useState(moment());

  const [focusedInput, setFocusedInput] = useState(null);
  const [calVisible, setCalVisible] = useState(false);

  const isSameDay = (date1, date2) => date1.isSame(date2, "day");

const renderDayContents = (day) => {
  let classNames = ["DayPicker-Day"];
  const isStart = startDate && day.isSame(startDate, "day");
  const isEnd = endDate && day.isSame(endDate, "day");
  const isRange = startDate && endDate && day.isBetween(startDate, endDate, "day", "[]");

  if (activeTransfer || activeLocal) {
    if (isStart) classNames.push("DayPicker-Day--start");
  } else if (activeOutstation) {
    if (isStart) classNames.push("DayPicker-Day--start");
    if (isEnd) classNames.push("DayPicker-Day--end");
    if (isRange) classNames.push("DayPicker-Day--range");
  }

  return (
    <div className={classNames.join(" ")}>
      <span style={{ fontWeight: "600", fontSize: "13px" }}>{day.format("D")}</span>
    </div>
  );
};


const handleDatesChange = ({ startDate: newStart, endDate: newEnd }) => {
  if (activeTransfer) {
    setStartDate(newStart); // Transfer uses startDate
    setEndDate(null);       // Transfer doesn’t have endDate
  } else if (activeOutstation) {
    setStartDate(newStart); // Outstation uses both startDate & endDate
    setEndDate(newEnd);
  } else if (activeLocal) {
    setStartDate(newStart); // Local only uses startDate
    setEndDate(null);
  }
};


  const toggleCalendar = (input) => {
    setCalVisible(!calVisible);
    if (!calVisible) {
      if (input === "startDate") {
        setFocusedInput("startDate");
      } else if (input === "endDate") {
        setFocusedInput("endDate");
      } else {
        setCalVisible(!calVisible);
        if (!calVisible) setFocusedInput("startDate");
        else setFocusedInput(null);
      }
    }
  };

  const handleChange = () => {};

  const [source, setSource] = useState({});
  const [destination, setDestination] = useState({});
  const [date, setDate] = useState("");

  const navigate = useNavigate();

const handleSubmit = (e) => {
  e.preventDefault();

  // Validate for Transfer and Local (only startDate needed)
  if ((activeTransfer || activeLocal) && !startDate) {
    toast.error("Please select a start date & time");
    return;
  }

  // Validate for Outstation (both startDate and endDate)
  if (activeOutstation) {
    if (!startDate) {
      toast.error("Please select departure date & time");
      return;
    }
    if (!endDate) {
      toast.error("Please select return date & time");
      return;
    }
    if (endDate.isBefore(startDate)) {
      toast.error("Return date/time cannot be before departure");
      return;
    }
  }

  let formDataToPass = {};

  if (activeTransfer) {
    formDataToPass = {
      tripType: "transfer",
      transferType,
      pickup: searchInput,
      drop: searchInput2,
      startDate: startDate.format("YYYY-MM-DD"),
      startTime: startDate.format("HH:mm"),
    };
  } else if (activeOutstation) {
    formDataToPass = {
      tripType: "outstation",
      pickup: outSearch,
      drop: outSearch2,
      startDate: startDate.format("YYYY-MM-DD"),
      startTime: startDate.format("HH:mm"),
      endDate: endDate.format("YYYY-MM-DD"),
      endTime: endDate.format("HH:mm"),
    };
  } else if (activeLocal) {
    if (!selectedHours) {
      toast.error("Please select hours");
      return;
    }
    formDataToPass = {
      tripType: "local",
      pickup: localSearch,
      drop: localSearch,
      startDate: startDate.format("YYYY-MM-DD"),
      startTime: startDate.format("HH:mm"),
      durationHours: selectedHours,
    };
  }

  console.log("Filled Data:", formDataToPass);

  // Convert object to query string for navigation
  const queryString = new URLSearchParams(formDataToPass).toString();
  navigate(`/cablisting?${queryString}`);
};


  const [clickDestination, SetClickDestination] = useState(false);
  const [clickDestination2, SetClickDestination2] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({
    code: "in",
    name: "India",
  });

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsOpen(false);
  };

  const [destinationCity, setDestinationCity] = useState("");
  const [selectedCityCode, setSelectedCityCode] = useState("");
  const [isItemSelected, setIsItemSelected] = useState(false);
  const [isItemSelected2, setIsItemSelected2] = useState(false);
  const [destination1, setDestination1] = useState("");
  const [destination2, setDestination2] = useState("");

  // For Transfer
  const [searchedAirport, setSearchedAirport] = useState(
    "DEL"
  );
  const [searchedAirport2, setSearchedAirport2] = useState(
    "BOM"
  );

  // For Outstation
const [outFromAirport, setOutFromAirport] = useState("DEL");
const [outToAirport, setOutToAirport] = useState("BOM");

// For Local (if needed, often same city)
const [localFromAirport, setLocalFromAirport] = useState("DEL");

  const handleCitySelect = (city) => {
    setDestinationCity(`${city["CITYNAME"]} (${city["AIRPORTCODE"]})`);
    setSearchedAirport(`${city["CITYCODE"]},${city["AIRPORTNAME"]}`);
    setSelectedCityCode(city["AIRPORTCODE"]);
    SetClickDestination(false); // Close the city suggestion div
    setSearchInput(`${city["CITYNAME"]} (${city["AIRPORTCODE"]})`); // Clear the search input after selecting a city
    setIsItemSelected(true);
    setDestination1(city);
  };

  const [destinationCity2, setDestinationCity2] = useState("");
  const [selectedCityCode2, setSelectedCityCode2] = useState("");


  // For Transfrom
  const [searchInput, setSearchInput] = useState("Delhi (DEL)");
  const [searchInput2, setSearchInput2] = useState("Mumbai (BOM)");
  
  // For Outstation
const [outSearch, setOutSearch] = useState("Delhi (DEL");
const [outSearch2, setOutSearch2] = useState("Mumbai (BOM)");

// For Local
const [localSearch, setLocalSearch] = useState("Delhi (DEL");


  const [cities2, setCities2] = useState([]);
  const [cities22, setCities22] = useState([]);


const fetchDatas = (value) => {
  axios
    .post("https://admin.travelsdata.com/api/Cab/City", { city: value })
    .then((response) => {
      const results = response.data.data.filter((item) =>
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.address.toLowerCase().includes(value.toLowerCase())
      );

      setCities2(results);
    })
    .catch((err) => console.error("API Error:", err));
};



const handleInputChange = (value) => {
  if (activeTransfer) {
    setSearchInput(value);
  } 
  else if (activeOutstation) {
    setOutSearch(value);
  }
  else if (activeLocal) {
    setLocalSearch(value);
  }

  SetClickDestination(true);
  setIsItemSelected(false);

  if (value.length === 3) {
    fetchDatas(value);
  }

  if (value.length < 3) {
    setCities2([]);
  }
};

const handleSourceSelect = (city) => {
  if (activeOutstation) {
    setOutSearch(city.name);       // input value
    setOutFromAirport(city.address); // airport display
  } else {
    setSearchInput(city.name);
    setSearchedAirport(city.address);
  }
  setIsItemSelected(true);
  SetClickDestination(false);
};

const fetchDatass = (value) => {
  axios
    .post("https://admin.travelsdata.com/api/Cab/City", { city: value })
    .then((response) => {
      const results = response.data.data.filter((item) =>
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.address.toLowerCase().includes(value.toLowerCase())
      );

      setCities22(results);
    })
    .catch((err) => console.error("API Error:", err));
};

const handleInputChange2 = (value) => {
  setSearchInput2(value);
  SetClickDestination2(true);
  setIsItemSelected2(false);

  // Call API ONE TIME at exactly 3 characters
  if (value.length === 3) {
    fetchDatass(value);
  }

  // Clear list when < 3 characters
  if (value.length < 3) {
    setCities22([]);
  }
};

const handleCitySelect2 = (city) => {
  if (activeOutstation) {
    setOutSearch2(city.name);       // input value
    setOutToAirport(city.address);  // airport display
  } else {
    setSearchInput2(city.name);
    setSearchedAirport2(city.address);
  }
  setIsItemSelected2(true);
  SetClickDestination2(false);
};

  const [time, setTime] = useState(""); // Stores selected time
  const inputRef = useRef(null); // Ref to access input DOM

  const handleDivClick = () => {
    if (inputRef.current) {
      inputRef.current.click(); // Open time picker on div click
    }
  };

  const handleTimeChange = (e) => {
    setTime(e.target.value); // Update selected time
  };

  const bookusdata = [
    {
      img: "/Images/Icons/esy-flights.svg",
      head: "Easy Booking",
      desc: " Book Flights Easily and Grab Exciting Offers!",
    },
    {
      img: "/Images/Icons/down-arrows.svg",
      head: "Lowest Price",
      desc: "Guaranteed Low Rates on Hotels, Holiday Packages, and Flights",
    },
    {
      img: "/Images/Icons/return-boxs.svg",
      head: "Instant Refund",
      desc: "Get Quick and Easy Refunds on All Your Travel Bookings!",
    },
    {
      img: "/Images/Icons/24-hoursa.svg",
      head: "24/7 Support",
      desc: "24/7 Support for All Your Travel Queries — We're Here to Help!",
    },
    {
      img: "/Images/Icons/hot-sales.svg",
      head: "Exciting Deals",
      desc: "Unlock Exciting Deals on Flights, Hotels, Buses, Car Rentals, and Tours!",
    },
  ];

  return (
    <div className="bookimg_form_containerrr">
      <div style={{ position: "relative" }}>
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          autoplay={{
            delay: 50000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper"
          style={{ height: "300px" }}
        >
          <SwiperSlide>
           <div
              className="backgroundBanner banner banner-image"
              style={{
                backgroundImage:
                  'url("https://images.pexels.com/photos/5834954/pexels-photo-5834954.jpeg")',
                backgroundPosition: "bottom",
                backgroundSize: "cover",
              }}
              data-v-0b3b4b19=""
              data-v-b9cf504c=""
            >
              <div
                className="overlay"
                style={{ backgroundColor: "#190a0a", opacity: "0.5" }}
              ></div>

              <img
                src="/Images/dream-feather-bg.png"
                alt="img-mark"
                className="img-mark"
                data-v-0b3b4b19=""
              />
              <h1 className="description" data-v-0b3b4b19="">
                <div>Search Cabs</div>
                <div>Smooth Cab Booking, Unbeatable Low Prices</div>
              </h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="backgroundBanner banner banner-image"
              style={{
                backgroundImage:
                  'url("https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIDz7XKDBARrLsQobGmrJ1uiYzZ6MOXxC9Ig&s")',
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
              data-v-0b3b4b19=""
              data-v-b9cf504c=""
            >
              <div
                className="overlay"
                style={{ backgroundColor: "#190a0a", opacity: "0.5" }}
              ></div>

              <img
                src="/Images/dream-feather-bg.png"
                alt="img-mark"
                className="img-mark"
                data-v-0b3b4b19=""
              />
              <h1 className="description" data-v-0b3b4b19="">
                <div>Unlock Exclusive Cabs Offers</div>
                <div>Cabs Discounts, and Business Travel Solutions Today</div>
              </h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="backgroundBanner banner banner-image"
              style={{
                backgroundImage:
                  'url("https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIDz7XKDBARrLsQobGmrJ1uiYzZ6MOXxC9Ig&s")',
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
              data-v-0b3b4b19=""
              data-v-b9cf504c=""
            >
              <div
                className="overlay"
                style={{ backgroundColor: "#190a0a", opacity: "0.5" }}
              ></div>

              <img
                src="/Images/dream-feather-bg.png"
                alt="img-mark"
                className="img-mark"
                data-v-0b3b4b19=""
              />
              <h1 className="description" data-v-0b3b4b19="">
                <div>Experience Hassle-Free Bookings</div>
                <div>Luxury Travel, and Unmatched Service Only on Innovate Blues</div>
              </h1>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      <Container>
        <div className="flightWidgetSection appendBottom40">
          <div className="searchWidgetContainer">
            <form
              onSubmit={handleSubmit}
              data-cy="flightSW"
              className="fltWidgetSection appendBottom40 primaryTraveler cabBookingSearch"
            >
              <div className="transferSection">
                <Row className="transferSectionTabs">
                  <Col
                    onClick={handleSearchTransfer}
                    className={`cabSearch-tab ${
                      activeTransfer ? "activeTransfer active" : ""
                    }`}
                  >
                    {/* <MdCardTravel /> */}
                    <div className="tabLabel">Transfer</div>
                  </Col>
                  <Col
                    onClick={handleSearchOutstation}
                    className={`cabSearch-tab ${
                      activeOutstation ? "activeOutstation active" : ""
                    }`}
                  >
                    {/* <BiTransferAlt /> */}
                    <div className="tabLabel  ">Outstation</div>
                  </Col>
                  <Col
                    onClick={handleSearchLocal}
                    className={`cabSearch-tab ${
                      activeLocal ? "activeLocal active" : ""
                    }`}
                  >
                    {/* <IoLocationOutline /> */}
                    <div className="tabLabel">Local</div>
                  </Col>
                </Row>
              </div>

              {activeTransfer && (
                <>
                  <div className="makeFlex hrtlCenter"></div>
                  <div className="fsw ">
                    <div className="fsw_inner returnPersuasion">
                      <div
                        className="flt_fsw_inputBox searchCity inactiveWidget"
                        style={{ width: "220px" }}
                      >
                        <label htmlFor="fromCity">
                          <span
                            style={{ marginTop: "20px" }}
                            className="lbl_input appendBottom10"
                          >
                            Airport Transfer
                          </span>
                          <select
                            style={{ border: "none" }}
                            className="cabSearchModify-selectOptions"
                            value={transferType}
                            onChange={(e) => setTransferType(e.target.value)}
                          >
                            <option>Airport PickUp</option>
                            <option>Airport Drop</option>
                          </select>
                          {/* <input
                                  data-cy="fromCity"
                                  id="fromCity"
                                  type="text"
                                  className="fsw_inputField lineHeight36 latoBlack font30"
                                /> */}
                        </label>
                        <div style={{ position: "relative" }}>
                          <div
                            className="cityselect"
                            // style={{
                            //   position: "absolute",
                            //   color: "black",
                            //   backgroundColor: "white",
                            //   border: "1px solid #cdcdcd",
                            //   display:
                            //     searchInput && clickDestination
                            //       ? "block"
                            //       : "none",
                            //   width: "100%",
                            //   zIndex: 9,
                            //   top: "-42px",
                            //   maxHeight: 300,
                            //   overflow: "auto",
                            //   scrollbarWidth: "thin",
                            // }}
                          >
                          </div>
                        </div>
                      </div>
                      <div
                        className="flt_fsw_inputBox searchCity inactiveWidget"
                        style={{ width: "220px" }}
                      >
                        <label htmlFor="fromCity">
                          <span className="lbl_input appendBottom10">From</span>
                          <input
                            data-cy="fromCity"
                            id="fromCity"
                            type="text"
                            className="fsw_inputField lineHeight36 latoBlack font30"
                            readOnly=""
                            defaultValue="Delhi"
                            value={searchInput}
                            onFocus={() => {
                              setSearchInput("");        
                              SetClickDestination(true);
                              setIsItemSelected(false);
                            }}
                            onBlur={() => {
                              if (isItemSelected) SetClickDestination(false);
                            }}
                            onChange={(e) => handleInputChange(e.target.value)}
                          />
                          <p
                            className="code makeRelative"
                            title="DEL, Delhi Airport India"
                          >
                            {/* <span
                              data-cy="defaultFromValue"
                              title=""
                              className="truncate airPortName "
                            >
                              {searchedAirport}
                            </span> */}
                          </p>
                        </label>
                        <div style={{ position: "relative" }}>
                          <div
                            className="cityselect"
                            style={{
                              position: "absolute",
                              color: "black",
                              backgroundColor: "white",

                              border: "1px solid #cdcdcd",
                              display:
                                searchInput && clickDestination
                                  ? "block"
                                  : "none",
                              width: "115%",
                              zIndex: 9,
                              top: "-38px",
                              maxHeight: 300,
                              overflow: "auto",
                              scrollbarWidth: "thin",
                              left:"-30px"
                            }}
                          >
{clickDestination ? (
  cities2.length > 0 ? (
    <div className="cityselect">
      {cities2.map((city, index) => (
        <div
          key={index}
          className="react-autosuggest__suggestion"
          onClick={() => handleSourceSelect(city)}
        >
          <div className="makeFlex">
            <img src="/Images/cabicons.png" className="icLocAltCab" />
            <div className="makeFlex flexOne column">
              <p className="font_search_bookingss">{city.name}</p>
              <p className="lightGreyText font12">{city.address}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    // Show loader only when user is typing 2+ characters
    searchInput.length >= 2 && (
      <div
        style={{
          padding: "10px 5px",
          fontSize: "12px",
          textAlign: "center",
          margin: "auto",
          width: "100%",
        }}
      >
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />{" "}
        Please wait, we are fetching city list...
      </div>
    )
  )
) : null}


                          </div>
                        </div>
                        <span className="fltSwipCircle">
                          <AiOutlineSwap color="#1a4f87" size={20} />
                        </span>
                      </div>

                      <div
                        className="flt_fsw_inputBox searchToCity inactiveWidget"
                        style={{ width: "220px" }}
                      >
                        <label htmlFor="toCity">
                          <span className="lbl_input appendBottom10">To</span>
                          <input
                            data-cy="toCity"
                            id="toCity"
                            type="text"
                            className="fsw_inputField lineHeight36 latoBlack font30"
                            readOnly=""
                            defaultValue="Mumbai"
                            value={searchInput2}
                            onFocus={() => {
                              setSearchInput2("");        
                              SetClickDestination2(true);  
                              setIsItemSelected2(false);   
                            }}
                            onBlur={() => {
                              if (isItemSelected2) SetClickDestination2(false);
                            }}
                            onChange={(e) => handleInputChange2(e.target.value)}
                          />
                          <p
                            className="code makeRelative"
                            title="BOM, Chhatrapati Shivaji International Airport India"
                          >
                            {/* <span
                              data-cy="defaultToValue"
                              title=""
                              className="truncate airPortName "
                            >
                              {searchedAirport2}
                            </span> */}
                          </p>
                        </label>
                        <div style={{ position: "relative" }}>
                          <div
                            className="cityselect"
                            style={{
                              position: "absolute",
                              color: "black",
                              backgroundColor: "white",

                              border: "1px solid #cdcdcd",
                              display:
                                searchInput2 && clickDestination2
                                  ? "block"
                                  : "none",
                              width: "115%",
                              zIndex: 9,
                              top: "-38px",
                              maxHeight: 300,
                              overflow: "auto",
                              scrollbarWidth: "thin",
                              left:"-31px",
                            }}
                          >
{clickDestination2 ? (
  cities22.length > 0 ? (
    <div className="cityselect">
      {cities22.map((city, index) => (
        <div
          key={index}
          role="option"
          aria-selected="false"
          className={`react-autosuggest__suggestion ${
            index === 0 ? "react-autosuggest__suggestion--first" : ""
          }`}
          onClick={() => handleCitySelect2(city)}
        >
          <div className="makeFlex">
            <img
              className="icLocAlt appendRight8-bookings_form"
              src="/Images/cabicons.png"
              alt="icon"
            />

            <div className="makeFlex flexOne column">
              <div className="makeFlex flexOne spaceBetween">
                <div className="makeFlex column flexOne appendRight10">
                  <p className="font_search_bookingss blackText appendBottom5">
                    {city.name}
                  </p>
                </div>
              </div>

              <p className="font12_bookingForm_ad greyText appendBottom3 lineHeight14">
                {city.address}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    searchInput2.length >= 2 && (
      <div
        style={{
          padding: "10px 5px",
          fontSize: "12px",
          textAlign: "center",
          margin: "auto",
          width: "100%",
        }}
      >
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />{" "}
        Please wait, we are fetching city list...
      </div>
    )
  )
) : null}

                          </div>
                        </div>
                      </div>

                      <div className="departure-picker">
                        <label htmlFor="departure" className="departure-label ">
                          Departure Date
                        </label>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            value={startDate}
                            onChange={(newValue) =>
                              setStartDate(dayjs(newValue))
                            }
                            minDateTime={dayjs()}
                            ampm
                            slots={{
                              openPickerIcon: () => (
                                <i className="fa-regular fa-calendar" />
                              ),
                            }}
                            slotProps={{
                              popper: {
                                placement: "bottom-start",
                                disablePortal: true, // <– forces it to attach to body
                                sx: { zIndex: 99999 },
                              },
                              textField: {
                                fullWidth: true,
                                size: "small",
                                placeholder: "Select date & time",
                                InputProps: {
                                  className: "departure-input",
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                      <div className="flt_fsw_inputBox dates reDates inactiveWidget search_flight_bookingsss ">
                        <button className="mat-stroked-button" type="submit">
                          Search Cab{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {activeOutstation && (
                <div className="fsw">
                  <div className="fsw_inner returnPersuasion">
                    {/* From City */}
                    <div className="flt_fsw_inputBox searchCity inactiveWidget" style={{ width: "220px" }}>
                      <label htmlFor="fromCity">
                        <span className="lbl_input appendBottom10">From</span>
                        <input
                          data-cy="fromCity"
                          id="fromCity"
                          type="text"
                          className="fsw_inputField lineHeight36 latoBlack font30"
                          value={outSearch}
                          placeholder="Enter From city"
                          onFocus={() => {
                            setOutSearch("");        
                            SetClickDestination(true);
                            setIsItemSelected(false);
                          }}
                          onBlur={() => setTimeout(() => SetClickDestination(false), 150)}
                          onChange={(e) => {
                            setOutSearch(e.target.value);
                            handleInputChange(e.target.value);
                          }}
                        />
                        <p className="code makeRelative" title="DEL, Delhi Airport India">
                          {/* <span data-cy="defaultFromValue" className="truncate airPortName">
                            {outFromAirport}
                          </span> */}
                        </p>
                      </label>
                      {clickDestination && (
                        <div className="cityselect" style={{
                          position: "absolute",
                          color: "black",
                          backgroundColor: "white",
                          border: "1px solid #cdcdcd",
                          width: "100%",
                          zIndex: 9,
                          top: "-38px",
                          maxHeight: 300,
                          overflow: "auto",
                        }}>
                          {cities2.length > 0 ? (
                            cities2.map((city, index) => (
                              <div key={index} className="react-autosuggest__suggestion" onClick={() => handleSourceSelect(city)}>
                                <div className="makeFlex">
                                  <img src="/Images/cabicons.png" className="icLocAltCab" />
                                  <div className="makeFlex flexOne column">
                                    <p className="font_search_bookingss">{city.name}</p>
                                    <p className="lightGreyText font12">{city.address}</p>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            outSearch.length >= 2 && <Spinner message="Fetching city list..." />
                          )}
                        </div>
                      )}
                    </div>

                    {/* To City */}
                    <div className="flt_fsw_inputBox searchToCity inactiveWidget" style={{ width: "220px" }}>
                      <label htmlFor="toCity">
                        <span className="lbl_input appendBottom10">To</span>
                        <input
                          data-cy="toCity"
                          id="toCity"
                          type="text"
                          className="fsw_inputField lineHeight36 latoBlack font30"
                          value={outSearch2}
                          placeholder="Enter To city"
                          onFocus={() => {
                            setOutSearch2("");  
                            SetClickDestination2(true);  
                            setIsItemSelected2(false);
                          }}
                          onBlur={() => setTimeout(() => SetClickDestination2(false), 150)}
                          onChange={(e) => {
                            setOutSearch2(e.target.value);
                            handleInputChange2(e.target.value);
                          }}
                        />
                        <p className="code makeRelative" title="BOM, Chhatrapati Shivaji International Airport India">
                          {/* <span data-cy="defaultToValue" className="truncate airPortName">{outToAirport}</span> */}
                        </p>
                      </label>
                      {clickDestination2 && (
                        <div className="cityselect" style={{
                          position: "absolute",
                          color: "black",
                          backgroundColor: "white",
                          border: "1px solid #cdcdcd",
                          width: "115%",
                          zIndex: 9,
                          top: "-38px",
                          left: "-30px",
                          maxHeight: 300,
                          overflow: "auto",
                        }}>
                          {cities22.length > 0 ? (
                            cities22.map((city, index) => (
                              <div key={index} className="react-autosuggest__suggestion" onClick={() => handleCitySelect2(city)}>
                                <div className="makeFlex">
                                  <img className="icLocAlt appendRight8-bookings_form" src="/Images/cabicons.png" alt="icon" />
                                  <div className="makeFlex flexOne column">
                                    <p className="font_search_bookingss blackText appendBottom5">{city.name}</p>
                                    <p className="font12_bookingForm_ad greyText appendBottom3 lineHeight14">{city.address}</p>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            outSearch2.length >= 2 && <Spinner message="Fetching city list..." />
                          )}
                        </div>
                      )}
                    </div>

                    {/* Departure Picker */}
                    <div className="departure-picker">
                      <label htmlFor="startDate" className="departure-label">Departure</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          value={startDate}
                          onChange={(newValue) => setStartDate(dayjs(newValue))}
                          minDateTime={dayjs()}
                          ampm
                          slotProps={{ textField: { fullWidth: true, size: "small", placeholder: "Select date & time", InputProps: { className: "departure-input" } } }}
                        />
                      </LocalizationProvider>
                    </div>

                    {/* Return Picker */}
                    <div className="departure-picker">
                      <label htmlFor="endDate" className="departure-label">Return</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          value={endDate}
                          onChange={(newValue) => setEndDate(dayjs(newValue))}
                          minDateTime={startDate || dayjs()}
                          ampm
                          slotProps={{ textField: { fullWidth: true, size: "small", placeholder: "Select date & time", InputProps: { className: "departure-input" } } }}
                        />
                      </LocalizationProvider>
                    </div>

                    {/* Search Button */}
                    <div className="flt_fsw_inputBox dates reDates inactiveWidget search_flight_bookingsss">
                      <button className="mat-stroked-button" type="submit">Search Cab</button>
                    </div>
                  </div>
                </div>
              )}
              {activeLocal && (
                <>
                  <div className="makeFlex hrtlCenter"></div>
                  <div className="fsw">
                    <div className="fsw_inner returnPersuasion">

                      {/* ------------------ LOCAL FROM INPUT ------------------ */}
                      <div
                        className="flt_fsw_inputBox searchCity inactiveWidget"
                        style={{ width: "550px" }}
                      >
                        <label htmlFor="fromCity">
                          <span className="lbl_input appendBottom10">From</span>

                          <input
                            data-cy="fromCity"
                            id="fromCity"
                            type="text"
                            className="fsw_inputField lineHeight36 latoBlack font30"
                            readOnly=""
                            defaultValue="Delhi"
                            value={localSearch}
                            onFocus={() => {
                              setLocalSearch("");
                              SetClickDestination(true);
                              setIsItemSelected(false);
                            }}
                            onBlur={() => {
                              if (isItemSelected) SetClickDestination(false);
                            }}
                            onChange={(e) => {
                              setLocalSearch(e.target.value);
                              handleInputChange(e.target.value); 
                            }}
                          />

                          <p className="code makeRelative" title="">
                            {/* <span
                              data-cy="defaultFromValue"
                              className="truncate airPortName"
                            >
                              {localFromAirport}
                            </span> */}
                          </p>
                        </label>

                        {/* Suggestions UI */}
                        <div style={{ position: "relative" }}>
                          <div
                            className="cityselect"
                            style={{
                              position: "absolute",
                              color: "black",
                              backgroundColor: "white",
                              border: "1px solid #cdcdcd",
                              display:
                                localSearch && clickDestination ? "block" : "none",
                              width: "100%",
                              zIndex: 9,
                              top: "-38px",
                              maxHeight: 300,
                              overflow: "auto",
                              scrollbarWidth: "thin",
                            }}
                          >
                            {clickDestination ? (
                              cities2.length > 0 ? (
                                <div className="cityselect">
                                  {cities2.map((city, index) => (
                                    <div
                                      key={index}
                                      className="react-autosuggest__suggestion"
                                      onClick={() => {
                                        setLocalSearch(city.name);
                                        setSearchedAirport(city.address);
                                        setIsItemSelected(true);
                                        SetClickDestination(false);
                                      }}
                                    >
                                      <div className="makeFlex">
                                        <img
                                          src="/Images/cabicons.png"
                                          className="icLocAltCab"
                                        />
                                        <div className="makeFlex flexOne column">
                                          <p className="font_search_bookingss">
                                            {city.name}
                                          </p>
                                          <p className="lightGreyText font12">
                                            {city.address}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                localSearch.length >= 2 && (
                                  <div
                                    style={{
                                      padding: "10px 5px",
                                      fontSize: "12px",
                                      textAlign: "center",
                                      margin: "auto",
                                      width: "100%",
                                    }}
                                  >
                                    <Spinner
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />{" "}
                                    Please wait, we are fetching city list...
                                  </div>
                                )
                              )
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {/* ------------------ DATE / TIME ------------------ */}
                      <div className="departure-picker">
                        <label htmlFor="departure" className="departure-label">
                          Departure
                        </label>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            value={startDate}
                            onChange={(newValue) => setStartDate(dayjs(newValue))}
                            minDateTime={dayjs()}
                            ampm
                            slots={{
                              openPickerIcon: () => (
                                <i className="fa-regular fa-calendar" />
                              ),
                            }}
                            slotProps={{
                              popper: {
                                placement: "bottom-start",
                                disablePortal: true,
                                sx: { zIndex: 99999 },
                              },
                              textField: {
                                fullWidth: true,
                                size: "small",
                                placeholder: "Select date & time",
                                InputProps: {
                                  className: "departure-input",
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>

                      {/* ------------------ PICKUP TIME ------------------ */}
                      <div className="flt_fsw_inputBox dates reDates inactiveWidget">
                        <div data-cy="pickupArea">
                          <label>
                            <span className="lbl_input appendBottom10">
                              Pick-up Time
                            </span>
                            <p
                              data-cy="pickupTime"
                              className="blackText font20 code lineHeight36"
                            >
                              <span className="font30 latoBlack">
                                <select
                                  className="pickupTimeDropdown"
                                  value={selectedHours}
                                  onChange={(e) => setSelectedHours(e.target.value)}
                                >
                                  <option value="">Select hours</option>
                                  {Array.from({ length: 12 }, (_, i) => (
                                    <option key={i + 1} value={`${i + 1} hrs`}>
                                      {i + 1} hrs
                                    </option>
                                  ))}
                                </select>
                              </span>
                            </p>
                          </label>
                        </div>
                      </div>

                      {/* ------------------ SUBMIT ------------------ */}
                      <div className="flt_fsw_inputBox dates reDates inactiveWidget search_flight_bookingsss">
                        <button className="mat-stroked-button" type="submit">
                          Search Cab
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}

            </form>
          </div>
        </div>
      </Container>
      <WebOffer />
      {/* <ReasonsToBook/> */}
      {/* <HotelsContainer/> */}
      <CabContainer />
      <WhyBookUsNew bookusdata={bookusdata} />
      {/* <MobileApp
        backgroundImage="https://www.shreecabs.com/img2/cabs2.jpg"
        title="Download Our Mobile App"
        description="Book the flight ticket and hotel with the huge discount. Refer friends and get generous bonuses from theirs orders."
      /> */}
      <AboutHome />
    </div>
  );
};

export default CabBookingForm;
